document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.site-header');
    const minScroll = 130;
    let lastScroll = window.scrollY;

    const updateHeader = () => {
        const currentScroll = window.scrollY;

        if (currentScroll < minScroll) {
            header.classList.remove('header-scroll-show', 'header-scroll-hide');
            return;
        }

        if (currentScroll > lastScroll) {
            // Scrolling down
            header.classList.remove('header-scroll-show');
            header.classList.add('header-scroll-hide');
        } else {
            // Scrolling up
            header.classList.remove('header-scroll-hide');
            header.classList.add('header-scroll-show');
        }

        lastScroll = currentScroll;
    };
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
});